import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonFunctions } from "src/app/CommonComponent/function/commonfunctions";
import { LosService } from "../../_LOS/services/los.service";
import { PartnerService } from "../../_Partner/services/partner.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { EncrDecrService } from "../../AuthGuard/EncrDecrService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { constantUrl } from "../../Shared/constantUrl";
import { DialogService } from "../../Shared/dialog.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { LmsService } from "../services/lms.service";
declare var $: any;

@Component({
  selector: "app-lms-amortization",
  templateUrl: "./lms-amortization.component.html",
  styleUrls: ["./lms-amortization.component.scss"],
})
export class LmsAmortizationComponent implements OnInit {
  currentUser: any;
  showSpinner: boolean = false;
  dataSource: any;
  dataSourcePartner: any;
  dataSourcePartnerAllocation: any;
  displayedColumns: string[] = [
    "Period",
    "DueDate",
    "EMI_Amount",
    "Principle",
    "Interest",
    "Outstanding_Principle",
  ];
  FileCheckingList: any[] = [];
  dataSourceAllocation: any;
  Cur_Date: any = new Date();
  // loanSummary: any = {};
  PLoan_Date: any;
  Data_FreezeDate: any;
  ShowImportAmortization: boolean = false;
  EmployeeProfileBaseUrl: any = constantUrl.apiProfilePicUrl;

  displayedColumnsAllocation: string[] = [
    "Voucher_Id",
    "VoucherDate",
    "Voucher_No",
    "EMI_No",
    "AllocatedAmt",
    "Principle",
    "Interest",
    "Action",
  ];

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  loading: boolean = false;
  amortizationListList: any[] = [];

  @Input() loanSummary: any;

  @Input() PageType: any;

  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  tab: any = "Amortization";
  tabs: any = "clist";

  isPartnerPortal: boolean = false;

  constructor(
    private dataSharingService: DataSharingService,
    private encdec: EncrDecrService,
    private snackBar: MatSnackBar,
    private router: Router,
    private losService: LosService,
    private lmsService: LmsService,
    private route: ActivatedRoute,
    private MasterService: MasterService,
    private dialog: DialogService,
    private _Partnerservice: PartnerService,
    private _commonfunctions: CommonFunctions
  ) { }

  ngOnInit() {
    console.log("loan sunmmary", this.loanSummary);
    this.dataSharingService.HeaderTitle.next("Amortization Chart");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.showSpinner = true;
    
    this.isPartnerPortal = this.router.url.toLowerCase().includes('/partner-dashboard/');

    if (this.isPartnerPortal) {
      this.tabs = ''; // Reset to ensure changeTabList runs
      this.changeTabList('plist');
    } else {
      this.tabs = 'clist';
      this.LMS_Get_Amortization_Chart();
      this.LMS_Get_EMI_Allocation();
    }

    console.log("data", this.amortizationListList);
    this.Data_FreezeDate = new Date(this.currentUser.Data_Freeze.split('T')[0]);
  }
  Get_Amortization_Chart() {
    this._Partnerservice.Partner_Get_Amortization_Chart({ LoanId: this.loanSummary.PLoan_Id }).subscribe((res: any) => {
      if (res.length > 0) {
        this.amortizationListList = res;
        this.dataSourcePartner = new MatTableDataSource(res);
        this.PLoan_Date = res[0].PLoan_Date
        this.getTotal();
        if (new Date(this.PLoan_Date) > this.Data_FreezeDate) {
          this.ShowImportAmortization = true;
        }
      }
      this.showSpinner = false;
    });
  }
  LMS_Get_Amortization_Chart() {
    this.lmsService
      .LMS_Get_Amortization_Chart({ Loan_Id: this.loanSummary.LoanId })
      .subscribe((res: any) => {
        res.forEach((val) =>
          this.amortizationListList.push(Object.assign({}, val))
        );
        // this.amortizationListList = res;
        //this.dataSource = new MatTableDataSource(res);
        res.forEach((val) =>
          this.FileCheckingList.push(Object.assign({}, val))
        );

        this.FileCheckingList = JSON.parse(
          JSON.stringify(this.FileCheckingList)
        );
        var data = [];
        res.forEach((val) => data.push(Object.assign({}, val)));

        console.log("red", res);
        this.dataSource = new MatTableDataSource(data);
        this.getTotal();
        this.showSpinner = false;
      });
  }
  getTotal() {
    var Interest = 0,
      principal = 0;
    this.amortizationListList.forEach((obj: any) => {
      if (obj.EMI_Amount == 0) {
        Interest = Interest + obj.Interest;
        principal = principal + obj.Principle;
      } else {
        obj.Interest = obj.Interest + Interest;
        obj.Principle = obj.Principle + principal;
        Interest = 0;
        principal = 0;
      }
    });
    let emiTotal = 0,
      principleTotal = 0,
      interestTotal = 0,
      outstanding_Principle = 0;

    this.amortizationListList = this.amortizationListList.filter(
      (item) => item.EMI_Amount !== 0
    );
    this.amortizationListList.forEach((obj: any, index: any) => {
      emiTotal = emiTotal + obj.EMI_Amount;
      principleTotal = principleTotal + obj.Principle;
      interestTotal = interestTotal + obj.Interest;
      outstanding_Principle = outstanding_Principle + obj.Outstanding_Principle;
    });
    if (this.amortizationListList.length > 0) {
      this.amortizationListList.push({
        DueDate: "Total",
        EMI_Amount: emiTotal,
        Principle: principleTotal,
        Interest: interestTotal,
        Outstanding_Principle: "",
        isBold: true,
      });
    }
    console.log("data", this.amortizationListList);
  }
  // exportTable(exporter: any) {
  //   exporter.exportTable('xls', { fileName: `lms-amortization-list`, sheet: 'Amortization' });
  // }

  exportAmortization(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "amortization_chart"
    ) as HTMLTableElement;
    const worksheetName = "Amortization_chart"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  exportAllocation(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "allocation_chart"
    ) as HTMLTableElement;
    const worksheetName = "Allocation_chart"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  // calculateEmiTotal() {

  //   let emiTotal = 0, principleTotal = 0, interestTotal = 0;
  //   this.amortizationListList.forEach((obj: any) => {
  //     emiTotal = emiTotal + obj.EMI_Amount;
  //     principleTotal = principleTotal + obj.Principle;
  //     interestTotal = interestTotal + obj.Interest;
  //   });
  //   if (this.amortizationListList.length > 0) {
  //     this.amortizationListList.push({ DueDate: "Total", EMI_Amount: emiTotal, Principle: principleTotal, Interest: interestTotal,isBold:true });
  //   }

  // if (this.dataSource != undefined) {
  //   if (
  //     this.dataSource != null &&
  //     this.dataSource != undefined
  //   ) {
  //     let sum = 0.0;
  //     for (let i = 0; i < this.dataSource.filteredData.length; i++) {
  //       sum += Number(this.dataSource.filteredData[i]["EMI_Amount"]);
  //     }
  //     return sum.toFixed(2);
  //   }
  //   return 0;
  // }
  // }

  changeTab(tab: any) {
    if (tab != this.tab) {
      this.tab = tab;
      if (this.tabs === 'plist' && tab === 'PartnerAllocation') {
        this.showSpinner = true;
        this.Partner_Get_EMI_Allocation();
      }
    }
  }
  changeTabList(tabs: any) {
    this.tab = "";
    if (tabs != this.tabs) {
      this.tabs = tabs;
    }
    if (tabs == "clist") {
      this.tab = "Amortization";
    }
    if (tabs == "plist") {
      this.tab = "PartnerAmortization";
      this.Get_Amortization_Chart();
      // If the currently selected tab inside partner view is PartnerAllocation, load allocation data
      if (this.tab === 'PartnerAllocation') {
        this.showSpinner = true;
        this.Partner_Get_EMI_Allocation();
      } else {
        // Optionally ensure that the amortization table is loaded (already called Get_Amortization_Chart)
      }
    }
  }

  LMS_Get_EMI_Allocation() {
    this.lmsService
      .LMS_Get_EMI_Allocation({ LoanId: this.loanSummary.LoanId })
      .subscribe((res: any) => {
        this.dataSourceAllocation = new MatTableDataSource(res);
        this.showSpinner = false;
      });
  }
  Partner_Get_EMI_Allocation() {
    this.lmsService
      .Partner_Get_EMI_Allocation({ LoanId: this.loanSummary.PLoan_Id })
      .subscribe((res: any) => {
        this.dataSourcePartnerAllocation = new MatTableDataSource(res);
        this.showSpinner = false;
      });
  }

  totaltypewise(type) {
    if (this.dataSourceAllocation != null) {
      let sum = 0;
      for (let i = 0; i < this.dataSourceAllocation.filteredData.length; i++) {
        sum += Number(this.dataSourceAllocation.filteredData[i][type]);
      }
      return sum > 0 ? sum : "";
    }
    return 0;
  }

  totaltypewiseAmortization(type) {
    if (this.dataSource != null) {
      let sum = 0;
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        sum += Number(this.dataSource.filteredData[i][type]);
      }
      return sum > 0 ? sum : "";
    }
    return 0;
  }
  totalPartnerAllocation(type: string) {
    if (this.dataSourcePartnerAllocation != null) {
      let sum = 0;
      for (let i = 0; i < this.dataSourcePartnerAllocation.filteredData.length; i++) {
        sum += Number(this.dataSourcePartnerAllocation.filteredData[i][type]);
      }
      return sum > 0 ? sum : "";
    }
    return 0;
  }

  LMSUpdateLoanEMIAllocation() {
    this.dialog
      .openConfirmDialog(`Are you sure? you want to regenerate allocation.`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.showSpinner = true;
          // console.log("ernk;jvad",this.loanSummary)
          this.lmsService
            .LMS_Update_Loan_EMIAllocation({ Loan_Id: this.loanSummary.LoanId })
            .subscribe((res: any) => {
              this.showSpinner = false;
              if (res[0].CODE == 0) {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
                this.LMS_Get_EMI_Allocation();
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
              }
            });
        }
      });
  }
  PartnerUpdateLoanEMIAllocation() {
    this.dialog
      .openConfirmDialog(`Are you sure? you want to regenerate allocation.`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.showSpinner = true;
          this.lmsService
            .Partner_Update_Loan_EMIAllocation({ Loan_Id: this.loanSummary.PLoan_Id })
            .subscribe((res: any) => {
              this.showSpinner = false;
              if (res[0].CODE == 0) {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
                this.Partner_Get_EMI_Allocation();  // Refresh partner allocation data
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
              }
            });
        }
      });
  }

  amortization_chart_print_Close() {
    $("#amortization_chart_print").modal("hide");
  }

  printdata() {
    $("#amortization_chart_print").modal("show");
    $("#amortization_chart_print").css("z-index", "1050");
  }

  onDocsPrint(divName, Header) {
    this._commonfunctions.PrintDocuments(divName, Header, "");
  }
  exportTablePartner(exporter: any) {
    exporter.exportTable('xls', {
      fileName: `partner-amortization-list`,
      sheet: 'partner-amortization-list'
    });
  }
  exportPartnerAllocation(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "partner_allocation_chart"
    ) as HTMLTableElement;
    const worksheetName = "Partner_Allocation_chart"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }
}
